import _ from 'lodash';
//get difference of two json object
export function formDataDifference(modifiedModel, initialModel) {
  function changes(modifiedModel, initialModel) {
    return _.transform(modifiedModel, function(result, value, key) {
      if (!_.isEqual(value, initialModel[key])) {
        result[key] = _.isObject(value) && _.isObject(initialModel[key]) ? changes(value, initialModel[key]) : value;
      }
    });
  }
  return changes(modifiedModel, initialModel);
}
